import { HttpInterceptor, HttpRequest, HttpHandler } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Actions, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { catchError, take, switchMap, throwError } from "rxjs";
import { RefreshTokenFailure, RefreshTokenRequest, RefreshTokenSuccess } from "../../store/auth/auth.actions";
import { AuthStoreService } from "../services";
import { Router } from "@angular/router";

function isPublicAuthBypassRoute(currentHash: string): boolean {
  return currentHash.startsWith('#/auth/reset-password')
    || currentHash.startsWith('#/auth/set-password')
    || currentHash.startsWith('#/sso/login')
    || currentHash.startsWith('#/calendar/join-token/')
    || currentHash.startsWith('#/call/');
}

@Injectable()
export class RefreshInterceptor implements HttpInterceptor {

  private refreshing = false;

  constructor(
    private store: Store,
    private actions$: Actions,
    private authStoreService: AuthStoreService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.url.includes('/refresh-token')) {
        return next.handle(req);
    }

    if (isPublicAuthBypassRoute(window.location.hash || '#/')) {
      return next.handle(req);
    }

    return next.handle(req).pipe(

      catchError(err => {

        // Only handle 401 + prevent multiple refresh calls
        if (err.status === 401) {
          if (!this.refreshing) {
            this.refreshing = true;
            this.store.dispatch(RefreshTokenRequest());
          }

          return this.actions$.pipe(
            ofType(RefreshTokenSuccess, RefreshTokenFailure),
            take(1),
            switchMap((action) => {
              this.refreshing = false;

              if (action.type === RefreshTokenFailure.type) {
                this.handleRefreshFailure();
                return throwError(() => err);
              }

              const token = this.authStoreService.token();
              if (!token) {
                this.handleRefreshFailure();
                return throwError(() => err);
              }

              const newReq = req.clone({
                setHeaders: {
                  Authorization: `Bearer ${token}`
                },
                withCredentials: true
              });

              return next.handle(newReq);
            }),
            catchError((refreshErr) => {
              this.refreshing = false;
              this.handleRefreshFailure();
              return throwError(() => refreshErr);
            })
          );
        }

        return throwError(() => err);
      })

    );
  }

  private handleRefreshFailure(): void {
    this.authStoreService.clear();
    const currentHash = window.location.hash || '#/';
    const isAuthTokenRoute = isPublicAuthBypassRoute(currentHash);
    if (!isAuthTokenRoute) {
      void this.router.navigate(['/auth/login']);
    }
  }
}
